// set layouts
import Restyle from '@/layouts/restyleLayout.vue';
import RestyleMobile from '@/layouts/restyleMobileLayout.vue';
import Empty from '@/layouts/Empty.vue';

//init global components
import btnPreload from '@/components/Preloaders/btn-preload';
import portalPagination from '@/components/helpers/pagination';
import List from '@/components/List/List';
import ListItem from '@/components/List/ListItem';
import restyle_button from "@/components/restyle/primitives/buttons/restyle_button";
import restyle_alert from "@/components/restyle/alert/restyle_alert";
import PaginationRestyle from '@/components/restyle/pagination/PaginationRestyle';
import IconWasteType from '@/components/restyle/primitives/icons/IconWasteType';
import PlusIcon from '@/components/restyle/primitives/icons/PlusIcon.vue';
import icon_button from '@/components/restyle/primitives/buttons/icon_button';
import switch_checkbox from '@/components/restyle/primitives/checkboxes/switch_checkbox';
import RestyleInput from '@/components/restyle/primitives/inputs/RestyleInput';
import RestyleSelect from '@/components/restyle/primitives/select/RestyleSelect';
import RestyleModal from '@/components/restyle/modal/RestyleModal';
import RestyleTooltip from '@/components/restyle/primitives/tooltips/RestyleTooltip';
import RestyleTextarea from '@/components/restyle/primitives/textarea/RestyleTextarea';

//https://www.npmjs.com/package/vue-draggable-resizable
import VueDraggableResizable from 'vue-draggable-resizable';

export const components = [
  RestyleMobile,
  btnPreload,
  Restyle,
  Empty,
  portalPagination,
  List,
  ListItem,
  restyle_button,
  restyle_alert,
  PaginationRestyle,
  IconWasteType,
  PlusIcon,
  icon_button,
  switch_checkbox,
  RestyleInput,
  RestyleSelect,
  RestyleModal,
  RestyleTooltip,
  RestyleTextarea,
  VueDraggableResizable,
];